import { type CreateContactInput } from '../../API';
import { getAircraftForUserId } from '../Aircrafts/AircraftsDatasource';
import { type AccessRights } from '../Contacts/AccessRights';
import { type WithCrewableUserFields } from '../Contacts/ContactsDatasource';
import { getCrewableContact } from '../Contacts/ContactsDatasource';
import { getDb } from '../LocalDB/LocalDB';
import { type WithId } from '../LocalDB/types';
import { type ContactUser, type User } from './User';

export const getUser = async (userId: string): Promise<User | null> => {
    const maybeContact = await getCrewableContact(userId);
    if (maybeContact) {
        return getUserFromContact(maybeContact, userId);
    }
    const maybeAircraft = await getAircraftForUserId(userId);
    if (maybeAircraft) {
        return {
            name: maybeAircraft.registration,
            userId,
            aircraftId: maybeAircraft.id,
        };
    }

    return null;
};

export const getUserIdForAircraft = async (aircraftId: string): Promise<string | undefined> => {
    const maybeAircraft = await getDb().aircrafts.get(aircraftId);
    if (maybeAircraft && maybeAircraft.userId) {
        return maybeAircraft.userId;
    }

    return undefined;
};

export const getUserFromContact = (
    maybeContact: CreateContactInput & WithCrewableUserFields & WithId,
    userId: string
): ContactUser => {
    let aircraftVisiblityLimitations = null;
    if (maybeContact.aircraftVisiblityLimitations) {
        try {
            aircraftVisiblityLimitations = JSON.parse(maybeContact.aircraftVisiblityLimitations);
        } catch (error) {
            console.error('Error parsing contact AC visibility limitations');
            console.error(error);
        }
    }

    const parsedLimitations = maybeContact.accessRights
        ? (JSON.parse(maybeContact.accessRights) as AccessRights)
        : undefined;

    let aircraftLimitations = maybeContact.fullReadAccessToAircrafts ?? parsedLimitations?.fullAccessAircratIds;

    aircraftLimitations = aircraftLimitations?.length === 0 ? undefined : aircraftLimitations;

    return {
        name: maybeContact.name,
        contactId: maybeContact.id,
        userId,
        crewId: maybeContact.crewId,
        hasDutyTracking: Boolean(maybeContact.hasDutyTracking),
        isReservationResource: Boolean(maybeContact.isReservationResource),
        aircraftVisiblityLimitations,
        fullReadAccessToAircrafts: aircraftLimitations || null,
        baseAirportIcaos: maybeContact.baseAirportIcaos || [],
        hasAccessToCustomerDatabase: parsedLimitations?.hasAccessToCustomerDatabase ?? true,
    };
};
